import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "../Logo";

const LINKS = [["Features", "#features"], ["Coaches", "#coaches"], ["Recruiters", "#recruiters"], ["How it works", "#how"]];

export const Nav = () => {
  const [solid, setSolid] = useState(false);
  useEffect(() => {
    const on = () => setSolid(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${solid ? "border-b border-white/5 bg-[#0A0E1A]/70 backdrop-blur-xl" : "border-b border-transparent"}`}>
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 sm:px-10">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([l, h]) => (
            <a key={h} href={h} data-testid={`nav-link-${l.toLowerCase().replace(/\s+/g, "-")}`} className="group relative text-sm text-slate-300 transition-colors hover:text-white">
              {l}<span className="absolute -bottom-1 left-0 h-px w-0 bg-[#39FF14] transition-[width] duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <Link to="/join" data-testid="nav-join-button" className="rounded-full border border-white/15 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:border-[#39FF14]/60">Join now</Link>
          <Link to="/login" data-testid="nav-login-button" className="group flex items-center gap-1.5 rounded-full bg-[#39FF14] px-4 py-2.5 text-sm font-bold text-[#0A0E1A] transition-[box-shadow] hover:shadow-[0_0_30px_rgba(57,255,20,0.45)] sm:px-5">
            Log in <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </div>
    </header>
  );
};
